export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.posted-bills-report.index`,
        path: `/${prefix}/${pre}/posted-bills-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.posted-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: posted Bills report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.posted-bills-report.index`,
        path: `/${prefix}/${pre}/posted-bills-report/print`,
        component: () => import('./prints/PostedBills.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.posted-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: posted Bills report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.print.posted-bill-items.index`,
        path: `/${prefix}/${pre}/posted-bill-items/print`,
        component: () => import('./prints/PostedBillDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.posted-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: posted Bills report",
            },
            print: true,
        },
    },
];